export function mapCoursesResponse(data) {
  return {
    enrolledCourses: data.enrolled_courses,
    myCourses: data.my_courses,
    challengeCourses: data.challenge_courses,
    sugarDoughCourses: data.sugar_dough_courses,
    artCourses: data.art_courses,
    businessCourses: data.business_courses,
    otherCourses: data.other_courses,
    sculptureMethodCourse: data.sculpture_method_course,
    nextZoomMeeting: data.next_zoom_meeting,
    nextChallengeCourse: data.next_challenge_course
  }
}

export function parseNextZoomMeeting(html) {
  const dom = new DOMParser().parseFromString(html, 'text/html')
  return {
    isShowLink:
      dom.querySelector('#next-zoom-meeting-is-show-link').textContent ===
      'true',
    date: dom.querySelector('#next-zoom-meeting-date').textContent,
    day: dom.querySelector('#next-zoom-meeting-day').textContent,
    time: dom.querySelector('#next-zoom-meeting-time').textContent,
    displayDateTime: dom.querySelector('#next-zoom-meeting-display-datetime')
      .textContent,
    link: dom.querySelector('#next-zoom-meeting-link').textContent
  }
}

export function parseNextChallengeCourse(html, enrolledCourses, nextChallengeCourse) {
  const dom = new DOMParser().parseFromString(html, 'text/html')
  return {
    isRegistered: nextChallengeCourse?.is_enrolled ?? false,
    isShowRegistration:
      dom.querySelector('#next-challenge-is-show-registration').textContent ===
      'true',
    isShowLink:
      dom.querySelector('#next-challenge-is-show-link').textContent === 'true',
    date: dom.querySelector('#next-challenge-date').textContent,
    day: dom.querySelector('#next-challenge-day').textContent,
    time: dom.querySelector('#next-challenge-time').textContent,
    displayDateTime: dom.querySelector('#next-challenge-display-datetime')
      .textContent,
    link: dom.querySelector('#next-challenge-link').textContent
  }
}

export function buildUserFromResponse(meData) {
  return {
    id: meData.id,
    fluent_crm_id: meData.fluent_crm_id,
    email: meData.email,
    phone: meData.phone,
    name: meData.name,
    invoice_name: meData.invoice_name,
    academy_start_date: meData.academy_start_date,
    academy_end_date: meData.academy_end_date,
    points: meData.points,
    num_of_payments: meData.num_of_payments
  }
}

export function authenticateCommands(meData, coursesData) {
  if (!meData) return []
  const user = buildUserFromResponse(meData)
  const commands = [
    {
      type: 'SET_STATE',
      payload: {
        user,
        isAdmin: meData.is_admin,
        isInAcademy: meData.is_in_academy
      }
    }
  ]
  if (coursesData) {
    const courses = mapCoursesResponse(coursesData)
    commands.push({ type: 'SET_COURSES', payload: courses })
    if (courses.nextZoomMeeting) {
      commands.push({
        type: 'SET_NEXT_ZOOM',
        payload: parseNextZoomMeeting(courses.nextZoomMeeting.content)
      })
    }
    if (courses.nextChallengeCourse) {
      commands.push({
        type: 'SET_NEXT_CHALLENGE',
        payload: {
          course: courses.nextChallengeCourse,
          ...parseNextChallengeCourse(
            courses.nextChallengeCourse.content,
            courses.enrolledCourses,
            courses.nextChallengeCourse
          )
        }
      })
    }
  }
  commands.push(
    {
      type: 'ANALYTICS_CONFIGURE',
      payload: { userId: meData.fluent_crm_id, email: meData.email }
    },
    { type: 'ANALYTICS_PERSIST', payload: user }
  )
  return commands
}

export function logoutCommands() {
  return [
    { type: 'SET_STATE', payload: { loading: true } },
    { type: 'API_CALL', method: 'logout' },
    { type: 'RESET_STATE' },
    { type: 'SET_STATE', payload: { loading: false } },
    { type: 'ANALYTICS_REMOVE' }
  ]
}
